import api from '../config/api';

export interface GalerieImage {
  id: number;
  titre: string;
  description?: string;
  image: string;
  categorie: string;
  section?: 'VCN' | 'HDR' | 'SANTE';
  nombre_vues: number;
  created_at: string;
}

export interface PaginatedResponse<T> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const galerieService = {
  getAll: async (page: number = 1, pageSize: number = 6, filters?: { categorie?: string; section?: string; search?: string }): Promise<PaginatedResponse<GalerieImage>> => {
    const params: any = { page, page_size: pageSize };
    if (filters?.categorie) params.categorie = filters.categorie;
    if (filters?.section) params.section = filters.section;
    if (filters?.search) params.search = filters.search;
    const response = await api.get('/galerie/images/', { params });
    if (response.data.results) {
      return {
        results: response.data.results,
        count: response.data.count || response.data.results.length,
        next: response.data.next || null,
        previous: response.data.previous || null
      };
    }
    // Fallback pour compatibilité
    const allData = Array.isArray(response.data) ? response.data : [response.data];
    return {
      results: allData,
      count: allData.length,
      next: null,
      previous: null
    };
  },

  getById: async (id: number): Promise<GalerieImage> => {
    const response = await api.get(`/galerie/images/${id}/`);
    return response.data;
  },

  incrementVue: async (id: number): Promise<void> => {
    await api.post(`/galerie/images/${id}/increment_vue/`);
  },
};

